
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-sitemap.xml",
      function () {
        return require("private-next-pages/career-sitemap.xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-sitemap.xml"])
      });
    }
  